// @flow

/**
 * Managing errors
 * @class ErrorManager
 */
class ErrorManager {
    /**
     * Throw an error taking in parameter a message and an optionnal code
     */
    static sendError(errorMessage: string, errorCode: number | null = null) {
        const errMsgFinal = errorCode
            ? `ERROR : code : ${errorCode} - message : ${errorMessage}`
            : `ERROR : message : ${errorMessage}`
        throw new Error(errMsgFinal)
    }

    /**
     * Displays a warning message
     * @param {string} warningMessage = the warning message
     */
    static sendWarning(warningMessage: string) {
        console.log(`WARNING : ${warningMessage}`)
    }
}

export default ErrorManager
